import { render, staticRenderFns } from "./ShareableTags.vue?vue&type=template&id=06bcbb95"
import script from "./ShareableTags.vue?vue&type=script&lang=js"
export * from "./ShareableTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports